import { render } from "./AddMillsModal.vue?vue&type=template&id=58dde85b&scoped=true"
import script from "./AddMillsModal.vue?vue&type=script&lang=js"
export * from "./AddMillsModal.vue?vue&type=script&lang=js"

import "./AddMillsModal.vue?vue&type=style&index=0&id=58dde85b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58dde85b"]])

export default __exports__